import { URL_ENDPOINTS } from '../../constants';
import {
  CommercialOffer,
  CommercialOfferInfo,
  CommercialOffersFlowsListResponse,
  CommercialOffersListResponse,
  FlowType,
} from '../../interfaces/CommercialOffer';
import { MerchantInfo } from '../../interfaces/MerchantInfo';
import { axiosInstance as Api } from '../../utils/api-helper';

const MerchantService = {
  getMerchantInfo: (): Promise<MerchantInfo> => {
    return Api.get(URL_ENDPOINTS.MERCHANT);
  },
  getCommercialOfferInfo: (
    data: CommercialOfferInfo
  ): Promise<CommercialOffersFlowsListResponse> => {
    return Api.get(
      URL_ENDPOINTS.COMMERCIAL_OFFER + `/${data.commercialOfferId}`,
      {
        params: {
          currency: data.currency,
          flows: data.flow,
        },
      }
    );
  },
  getCommercialOffersList: (
    flowD: string
  ): Promise<CommercialOffersListResponse> => {
    return Api.get(URL_ENDPOINTS.COMMERCIAL_OFFER, {
      params: {
        currency: 'EUR',
        flow: flowD,
      },
    });
  },
  getCommercialOffersFlowsList: (
    flows: FlowType[]
  ): Promise<CommercialOffersFlowsListResponse> => {
    const params = new URLSearchParams();
    params.append('currency', 'EUR');
    flows.forEach((flow) => params.append('flows', flow.toString()));
    return Api.get(`${URL_ENDPOINTS.COMMERCIAL_OFFER}?${params.toString()}`);
  },
};

export default MerchantService;
